// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import SearchPage from '../components/SearchPage.vue'
import SearchResultTable from '../components/SearchResultTable.vue'

const routes = [
  {
    path: '/',
    name: 'SearchPage',
    component: SearchPage
  },{
    path: '/results',
    name: 'SearchResultTable',
    component: SearchResultTable,
    props: router => ({ query: router.query.q })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router